
export class SvgService
{
    public get(productType) {
        if (productType === 'door') {
            // @todo: add svg for door
            const withDimensions = Array.from(document.getElementsByClassName('icc-door-draw-wrapper'))[0].innerHTML;
            const withoutDimensions = this.removeDimensionsFromDoorSvg(withDimensions);

            return [
                this.clear(withDimensions),
                this.clear(withoutDimensions),
            ];
        } else if (productType === 'roof_window') {
            return [
                null,
                null,
            ];
        } else {
            // @todo: add svg without dimensions or push merge 535
            const withDimensions = Array.from(document.getElementsByTagName('icc-draw'))[0].innerHTML;
            const withoutDimensions = Array.from(document.getElementsByTagName('icc-draw'))[0].innerHTML;

            return [
                this.clear(withDimensions),
                this.clear(withoutDimensions),
            ];
        }
    }

    private removeDimensionsFromDoorSvg(svgContent) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = svgContent;
        const elements = wrapper.querySelectorAll('.BottomDimension, .SideDimension');

        elements.forEach((element) => {
            element.parentNode.removeChild(element);
        });

        return wrapper.innerHTML;
    }

    private clear(svgContent) {
        let result = svgContent.toString().trim().replace(/<!--(?!>)[\S\s]*?-->/g, '');
        const toChange = result.match(/id="iccDraw(?:[^"]*)"/g);

        if (toChange !== null) {
            toChange.forEach((element) => {
                const toChangeIdFrom = element.replace('id="', '').replace('"', '');
                const toChangeIdTo = toChangeIdFrom.replace(/-/g, '');

                result = result.replace(new RegExp(toChangeIdFrom, 'g'), toChangeIdTo);
                result = result.replace(/&quot;/g, '');
            });
        }
        result = result.replace(/"url\('?http(.*?)#(.*?)'?\)"/g, 'url(\'#$2\')');

        return result;
    }
}
